import { render } from "./ShipmentMap.vue?vue&type=template&id=8becd83c&ts=true"
import script from "./ShipmentMap.vue?vue&type=script&lang=ts"
export * from "./ShipmentMap.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__